import PropTypes from 'prop-types'
import React from 'react'

const createMarkup = (markup = '') => {
  if (typeof markup !== 'string') {
    throw new Error('must have a single html string as a child.')
  }
  return { __html: `${markup}` }
}

const InnerHtml = ({className = null, children}) => {
  return (
    <div className={className} dangerouslySetInnerHTML={createMarkup(children)} />
  )
}

InnerHtml.propTypes = {
  className: PropTypes.string
}

export default InnerHtml



// WEBPACK FOOTER //
// ./client/components/innerHtml.js